module.exports = __webpack_public_path__ + "static/media/resourcesError.75e0faad.svg";